import React from 'react';
import { useParams, useNavigate, useLocation } from 'react-router-dom';
import { ExpertiseDetailPage } from '@/ui/components/pages/expertise-detail';

export const ReportDetail: React.FC = () => {
  const { reportId } = useParams<{ reportId: string }>();
  const navigate = useNavigate();
  const location = useLocation();
  
  // Get return path from location state or default to reports
  const returnPath = location.state?.from || '/client/reports';
  
  const handleBack = () => {
    navigate(returnPath);
  };
  
  // Use the ExpertiseDetailPage component with the report ID (affaire ID)
  return (
    <ExpertiseDetailPage
      dossierId={reportId}
      backUrl={returnPath}
      showActions={false}
      onBack={handleBack}
    />
  );
};